module.exports = __webpack_public_path__ + "images/f780d7ba0432bcc33f7b4b402d22c15a-illu_panelBattery.svg";